// Formatting for the billing page: money without needless decimals (19 990 Ft,
// 49 €, 0,04 €), months, card expiry.

const LOCALES = { hu: 'hu-HU', en: 'en-GB' };

export const localeOf = (lang) => LOCALES[lang] || 'en-GB';

export function formatMoney(amount, currency, lang) {
  if (amount == null || !Number.isFinite(Number(amount))) return '—';
  const n = Number(amount);
  const whole = Number.isInteger(n);
  try {
    return n.toLocaleString(localeOf(lang), {
      style: 'currency',
      currency: currency || 'HUF',
      // "49 €", not "49 EUR" (hu-HU prints the code with the default).
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: whole ? 0 : 2,
      maximumFractionDigits: whole ? 0 : 2,
    });
  } catch {
    return `${n.toLocaleString(localeOf(lang))} ${currency || ''}`.trim();
  }
}

export function formatPercent(rate, lang) {
  if (rate == null) return '—';
  return `${(Number(rate) * 100).toLocaleString(localeOf(lang), { maximumFractionDigits: 1 })}%`;
}

/// 'YYYY-MM' → "2026. november" / "November 2026".
export function formatPeriod(period, lang) {
  const [y, m] = String(period).split('-').map(Number);
  if (!y || !m) return String(period || '');
  return new Date(y, m - 1, 1).toLocaleDateString(localeOf(lang), { year: 'numeric', month: 'long' });
}

/// Invoice period bounds are UTC timestamps (Stripe's); read them in UTC so a
/// 23:59:59Z end does not turn into the next day in Budapest.
export function formatDay(iso, lang) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString(localeOf(lang), { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' });
}

export function formatExpiry(month, year) {
  if (!month || !year) return '—';
  return `${String(month).padStart(2, '0')}/${String(year).slice(-2)}`;
}

/// The card's last valid day has passed.
export function isExpired(month, year, today = new Date()) {
  if (!month || !year) return false;
  return new Date(Number(year), Number(month), 1) <= today;
}
